export function tiktokMarketGames(games, growthWindow = "7d", sort = "views", metric = "views") {
  const rows = games.map(game => {
    const totalKey = metric === "videos" ? "videosTotal" : "viewsTotal";
    const value = game.rankedMetrics ? game[totalKey] : Number(game[totalKey] ?? game[metric]);
    const window = game[`window_${growthWindow}`];
    const delta = window
      ? window.available && Number.isFinite(window[metric]) ? window[metric] : null
      : Number(game[`${metric === "videos" ? "videoGrowth" : "viewGrowth"}_${growthWindow}`] ?? 0);
    const previous = (game.metricLabel ? Number(game[metric]) : value) - delta;
    return {
      ...game,
      name: game.displayName || game.name,
      marketMetric: metric,
      id: game.selectionKey || game.gameKey || game.name,
      mindshare: value,
      growthPT: delta != null && previous > 0 ? delta / previous : 0,
      delta,
    };
  }).filter(game => Number.isFinite(game.mindshare) && game.mindshare > 0 &&
    (sort !== "growth" || game.delta != null));
  return rows.sort((a, b) => sort === "growth"
    ? b.growthPT - a.growthPT || b.mindshare - a.mindshare
    : b.mindshare - a.mindshare);
}
